import { PLATFORM, SupportedPlatformsEnum } from 'src/dataSource/types'
import { type Platforms } from 'shared/api/accounts'
import { type ConnectorPlatformType, ConnectorPlatformTypes } from './types'
import { ASSETS_BASE_URL } from 'shared/constants'
import { generateOauthLoginUrl } from 'src/dataSource/oauthUrls'
import { type IPlatform } from 'src/dataSource/constants'

export const SYSTEM_GENERATED_CONNECTORS_BQ_PROJECT_ID = 'pd-data-lake-01'

export const DEFAULT_BQ_DATASET = 'alvie_connectors'

export const SERVICE_DATASOURCE_MAP: Partial<Record<ConnectorPlatformType, Platforms>> = {
  [ConnectorPlatformTypes.GOOGLE_ANALYTICS]: PLATFORM.ANALYTICS,
  [ConnectorPlatformTypes.GOOGLE_ADS]: PLATFORM.GOOGLE,
  [ConnectorPlatformTypes.BING]: PLATFORM.MICROSOFT_ADVERTISING,
  [ConnectorPlatformTypes.LINKEDIN_ADS]: PLATFORM.LINKEDIN
} as const

export const MERCHANT_PLATFORM: IPlatform = {
  label: 'Google Merchant Center',
  platform: 'merchant' as Platforms,
  iconUrl: `${ASSETS_BASE_URL}/merchant_center.svg`,
  commonIconUrl: `${ASSETS_BASE_URL}/google.svg`,
  oauthUrl: generateOauthLoginUrl(SupportedPlatformsEnum.GOOGLE),
  isSupportedByChannelGrouping: false,
  externalEntityLabel: 'account',
  externalEntitiesLabel: 'accounts',
  supportsServiceAccountAccess: false,
  isManualAccountInput: false,
  isThirdPartyProvider: false,
  category: 'Other',
  isInternalOnly: false
}

export const CONNECTOR_DEPRECATIONS_REGISTRY: Partial<Record<ConnectorPlatformType, { deprecationDate: string }>> = {
  [ConnectorPlatformTypes.GOOGLE_ANALYTICS]: {
    deprecationDate: '2025-05-30'
  },
  [ConnectorPlatformTypes.LINKEDIN]: {
    deprecationDate: '2026-12-09'
  }
}

export const INTERNAL_FEATURE_ACCESS_PLATFORMS: Platforms[] = [PLATFORM.SHOPIFY, PLATFORM.CHATGPT_ADS]
